import Vue from "vue";
import Vuetify from "vuetify";
import axios from "axios";
import App from "./App.vue";
import VueGtag from "vue-gtag";
import router from "./router";
import store from "./store";
import "material-design-icons-iconfont/dist/material-design-icons.css";
import "vuetify/dist/vuetify.min.css";
import "@/stylus/main.styl";

// --- 0. SESSION EXPIRY ---
// A 401 means the token used for that request is invalid/expired. Figure out
// which session it belonged to (by comparing the Authorization header that
// was actually sent) and clear it so the app drops back to a login prompt
// instead of leaving the user stuck retrying with a dead token.
axios.interceptors.response.use(
  response => response,
  error => {
    if (error.response && error.response.status === 401) {
      const authHeader =
        (error.config &&
          error.config.headers &&
          error.config.headers.Authorization) ||
        "";
      if (
        store.state.providerToken &&
        authHeader === `Bearer ${store.state.providerToken}`
      ) {
        store.commit("assignProviderToken", "");
        if (router.currentRoute.name !== "Provider-Login") {
          router.push({
            name: "Provider-Login",
            query: { redirect: router.currentRoute.fullPath, expired: "1" }
          });
        }
      } else if (
        store.state.adminToken &&
        authHeader === `Bearer ${store.state.adminToken}`
      ) {
        // Admin.vue reactively falls back to the login form as soon as
        // adminToken is cleared, so no explicit navigation is needed here.
        store.commit("clearAdminToken");
      }
    }
    return Promise.reject(error);
  }
);

// --- 1. RETRIEVE KIOSK ID ---
// We get this once on startup.
const kioskId = localStorage.getItem("kiosk_machine_id");

// setup vuetify globally
Vue.use(Vuetify, {
  theme: {
    primary: "#324e6b",
    secondary: "#600627"
  }
});

// --- 2. SETUP GOOGLE ANALYTICS WITH KIOSK ID ---
Vue.use(
  VueGtag,
  {
    config: {
      id: "G-45VEZ5296L",
      params: {
        // Wrap custom User-scoped dimensions inside 'user_properties'
        user_properties: {
          kiosk_id: kioskId || "standard_user"
        }
      }
    },
    appName: "Fort Meade Resiliency Services",
    pageTrackerScreenviewEnabled: true
  },
  router
);

// --- 3. HEARTBEAT LOGIC (ONLY FOR KIOSKS) ---
// If this is a standard user (no ID), this block is skipped entirely.
if (kioskId) {
  const sendHeartbeat = () => {
    fetch("/api/kiosks/heartbeat", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        kiosk_id: kioskId,
        status: "online",
        timestamp: new Date().toISOString()
      })
    }).catch(err => console.error("Heartbeat failed:", err));
  };

  // Send one immediately on load
  sendHeartbeat();

  // Then send one every 20 minutes (1,200,000 ms)
  setInterval(sendHeartbeat, 1200000);
}

Vue.config.productionTip = false;

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount("#app");
